<template>
  <div>
    
    <p>{{ lang.infotext_1 }}:</p>
    <div v-if="requestDetails != undefined" class="list-details">
      <b-list-group>
        <b-list-group-item>{{lang.label_requestNumber}}: {{requestDetails.requestNumber}}</b-list-group-item>
        <b-list-group-item>{{lang.label_createDate}}: {{longDateToShort(requestDetails.creationDate)}}</b-list-group-item>
        <b-list-group-item>{{lang.label_requester}}: {{requestDetails.requestor}}</b-list-group-item>
        <b-list-group-item>{{lang.label_owner}}: {{requestDetails.owner}}</b-list-group-item>
        <!-- <b-list-group-item>{{lang.label_status}}: <b-badge :class="'badge badge-'+ getStatusColor(requestDetails.status)">{{requestDetails.status}} </b-badge></b-list-group-item> -->
        <b-list-group-item>{{lang.label_stage}}: {{requestDetails.stage}}
          <br>
          <b-progress :max="0" :value="requestDetails.progress" :variant="progressVariant" height="5px"></b-progress>
        </b-list-group-item>
        <b-list-group-item v-if="requestDetails.type == 'part'">{{lang.label_type}}: {{requestDetails.type}}</b-list-group-item>
        <b-list-group-item v-if="requestDetails.type != 'part'">{{lang.label_type}}: lib ({{requestDetails.libraryType}})</b-list-group-item>
        <b-list-group-item>{{lang.label_partNumber}}: {{requestDetails.partNumber}}</b-list-group-item>
        <b-list-group-item v-if="requestDetails.type != 'part'">{{lang.label_libraryNumber}}: {{requestDetails.libraryNumber}}</b-list-group-item>
        
        
      </b-list-group>
      <LoaderComponent v-if="requestDetails == undefined"></LoaderComponent>
    </div>
    <br>
 </div>
</template>

<script>
//import { mapState, mapMutations, mapActions, mapGetters, mapTypes } from 'vuex'
import LoaderComponent from "@/components/shared/LoaderComponent"
import * as Tools from '@/Tools/Tools' 
import { get } from "jquery";

export default {
  name: 'RequestInfoComponent',
  props:{
    lang: Object
  },
  components: {
    LoaderComponent

  },
  data () {
      return {
        requestDetails: null,
        name: "RequestInfoComponent"
      }
  },
  computed: {
    progressVariant(){

      let progress = this.requestDetails.progress;
              
      let variantProgress = "success";
      if (progress < 30) {
        variantProgress = "warning";
      }
      if (progress >= 30 && progress < 70) {
        variantProgress = "info";
      }
              
      return variantProgress;


    },
    reloadedAfterActionComplex() {
      return this.$store.getters.reloadedAfterActionComplex;
    },
  },
  created() {
    
    this.getRequestDetails();

  },
  watch: {
    reloadedAfterActionComplex: {
      handler: function (newValue) {

        for (let el in newValue) {

          if (newValue[el].name == this.name) {

            if (newValue[el].status == true) {

              this.getRequestDetails();

              newValue[el].status = false;

              this.$store.dispatch("reloadAfterActionComplex", newValue[el]);
            }
          }
        }
      },
      deep: true

    },
  },
  updated() {



  },
 

  methods: {
    
    longDateToShort(date) {
      return Tools.longDateToShort(date);
    },
    getStatusColor(data) {
      return Tools.getStatusColor(data);
    },
    getRequestDetails() {
      
      let vue = this;

      const obj = {
        requestId: this.$route.query.requestId
      }

      this.$store.dispatch(this.$store.getters.sectionPrefix + '_getRequest', obj)
          .then((result) => {
            console.log(result)
            if (result.status == "OK") {

              

              vue.requestDetails = result.data;

              vue.$store.commit("SETREQUESTDETAILS", result.data);
              
            }
            
        })

      
    }


  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .list-group-item{
    margin-top: 5px;
  }
  .progress{
    margin: 5px;
    margin-top: 15px;
  }
</style>


// WEBPACK FOOTER //
// src/components/shared/RequestInfoComponent.vue